import { render, staticRenderFns } from "./tagSubscribeMy.vue?vue&type=template&id=31c92aa7&scoped=true"
import script from "./tagSubscribeMy.vue?vue&type=script&lang=js"
export * from "./tagSubscribeMy.vue?vue&type=script&lang=js"
import style0 from "./tagSubscribeMy.vue?vue&type=style&index=0&id=31c92aa7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c92aa7",
  null
  
)

export default component.exports